// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"style_modal-content__hwcZg","close-button":"style_close-button__2CJ1u"};